module.exports = __webpack_public_path__ + "static/1fortylive2-9fc1e148c129f8e96ad87430c9f5ca57.jpg";